import { CartLineT, NoteT } from '@lambda/apis/src/cart/types';
import {
  CartLineWithRCareSpecs,
  CartProviderResults,
} from '@/utils/hooks/cart/types';

export const isDeliverableItem = (title: string) =>
  !title.toLowerCase().includes('reebelocare') &&
  !title.toLowerCase().includes('gift card') &&
  !title.toLowerCase().includes('express shipping');

export const updateLineItemNotes = ({
  lineItem,
  notes,
}: {
  lineItem: CartLineT;
  notes: Map<string, string>;
}) => {
  const updatedNotes = lineItem?.notes
    ?.map((note) => {
      const { name } = note;

      if (notes.has(name)) {
        return {
          name,
          value: notes.get(name) as string,
        };
      }

      return note;
    })
    .filter(Boolean) as Array<NoteT>;

  return updatedNotes;
};

export const updateParentItemDeliveryNotes = async ({
  parentItem,
  update,
  notes,
}: {
  parentItem: CartLineWithRCareSpecs;
  update: CartProviderResults['updateCart'];
  notes: Map<string, string>;
}) => {
  notes.set('_shipping_option', 'standard');
  notes.set('_shipping_option_cost', '0');

  await update(parentItem.id, {
    quantity: parentItem.quantity,
    notes: updateLineItemNotes({
      lineItem: parentItem,
      notes,
    }),
  });
};

export const maxQuantityPerOrder: Record<string, number> = {
  'P-SKINNYTRIOSIM': 10,
  'P-SPARKQUICKPREPAID3IN1SIM': 10,
};
